import { Injectable } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { Subject, Observable } from 'rxjs'
import { filter } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class LoggedInService {
  private userLoggedIn = new Subject<boolean>()

  //NOTE: Must have at least 3 levels of depth. Ex: '/transaccional/autogestion/firc
  protectedRoutesRegex = /\/[^/]+\/[^/]+\/[^/]+/

  constructor(private router: Router) {
    this.userLoggedIn.next(false)

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.handleEnableLogging(event)
      })
  }

  public handleEnableLogging(event: any) {
    const { url } = event as { url: string }
    if (this.protectedRoutesRegex.test(url)) this.userLoggedIn.next(true)
    else this.userLoggedIn.next(false)
  }

  public setUserLoggedIn(userLoggedIn: boolean) {
    this.userLoggedIn.next(userLoggedIn)
  }

  public getUserLoggedIn(): Observable<boolean> {
    return this.userLoggedIn.asObservable()
  }
}
